import {
  buildDeserializer,
  buildSerializer,
  SerializeMap,
} from "lib/serializerUtils";

export const sideLoadedDataMappingSerializeMap: SerializeMap<SideLoadedDataMapping> =
  {
    id: "id",
    name: "name",
    entries: {
      sourceColumn: "source_column",
      targetFieldKey: "target_field_key",
    },
    sourceColumns: "source_columns",
    created: "created",
    datasetId: "dataset_id",
  };

export const serializeSideLoadedDataMapping = buildSerializer(
  sideLoadedDataMappingSerializeMap,
  "sideLoadedDataMapping",
);

export const deserializeSideLoadedDataMapping = buildDeserializer(
  sideLoadedDataMappingSerializeMap,
  "sideLoadedDataMapping",
);
